<template>
  <a-modal
    :title="$t('sortModel.title')"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
  >
    <a-form-model :model="form" :rules="rules" ref="sortForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
      <a-form-model-item :label="$t('sortModel.valueLabel')" prop="weight" style="margin-bottom: 0">
        <a-input-number
          v-model="form.weight"
          :min="1"
          :max="500"
          :precision="0"
          style="width: 100%"
          :placeholder="$t('sortModel.placeholder')"
        />
      </a-form-model-item>
      <!-- <div class="tip-text">支持1-500，数值越大权重越高，优先排序。</div> -->
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateResourceWeight } from '@/api/lesson'
export default {
  name: 'SortModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentWeight: {
      type: Number,
      default: 1
    },
    resourceId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        weight: 1
      },
      rules: {
        weight: [
          { required: true, message: this.$t('sortModel.weightRequired') },
          { type: 'number', min: 1, max: 500, message: this.$t('sortModel.weightRange') }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.weight = this.currentWeight
      }
    },
    'form.weight'(val) {
      if (val > 500) {
        this.form.weight = 500
      }
    }
  },
  methods: {
    async handleOk() {
      try {
        const valid = await this.$refs.sortForm.validate()
        if (valid) {
          this.confirmLoading = true
          // 调用接口更新权重
          // await this.$api.updateResourceWeight({
          //   id: this.resourceId,
          //   weight: this.form.weight
          // })
          await updateResourceWeight({
            id: this.resourceId,
            order: this.form.weight
          })
          this.$message.success(this.$t('sortModel.setSuccess'))
          this.$emit('success')
          this.$emit('cancel')
        }
      } catch (error) {
        console.error(error)
        this.$message.error(this.$t('sortModel.setFailed'))
      } finally {
        this.confirmLoading = false
      }
    },
    handleCancel() {
      this.$emit('cancel')
      this.$refs.sortForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.tip-text {
  color: #999;
  font-size: 14px;
  margin-top: -10px;
}
</style>